<template>
  <div
    class='talentbank-selectable__tag'
    :class="{'talentbank-selectable__tag--selected':selected}"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang='scss'>
</style>
